export const CVEntries = [
	{
		title: "Interesses",
		entryType: "planet",
		entries: [
			{
				title: "Netflix",
				icon: "logos/netflix.svg",
				id: "netflix"
			},
			{
				title: "Muziek",
				icon: "headphone.svg",
				id: "music"
			},
			{
				title: "Lezen",
				icon: "book.svg",
				id: "reading"
			},
			{
				title: "Spellen",
				icon: "chess.svg",
				id: "games"
			},
			{
				title: "Films",
				icon: "3dglasses.svg",
				id: "movies"
			}
		]
	},
	{
		title: "Skills",
		entryType: "stars",
		entries: [
			{
				title: "Linux",
				id: "linux",
				icon: "logos/tux.svg", 
				description: `Voor zowel ontwikkeling als productieserver gaat mijn preferentie naar Linux. 
				Hierbij heb ik ervaring met zowel visuele als pure server varianten.`
			},
			{
				title: "MySQL",
				id: "mysql",
				icon: "logos/mysql.svg",
				description: `De afgelopen paar jaren heb ik applicaties ontwikkelt in een team die gebruik maken van een MySQL database. Ik kan een databasestructuur opzetten die zo efficient mogelijk is.`
			},
			{
				title: "PHP",
				id: "php",
				icon: "logos/php.svg",
				description: `Op het gebied van PHP heb ik ervaring met zowel het visueel weergeven van een pagina maar ook het maken en onderhouden van een PHP applicatie die via een SOAP service communiceert met Java.`
			},
			{
				title: "Java",
				id: "java",
				icon: "logos/java.svg",
				description: `Door de jaren heen ben ik steeds meer met Java gaan werken. Ik heb ervaring gekregen met de basis van programmeerstructuren, ORM in de vorm van Hibernate en SOAP webservices. In de toekomst zou ik mijn kennis van Java graag uit willen breiden.`
			},
			{
				title: "JavaScript",
				id: "javascript",
				icon: "logos/javascript.svg", 
				description: `Vrijwel onontkoombaar als gemixde Frontend/Backend developer, JavaScript is de taal waarmee ik begon met webontwikkeling.
				Na enkele jaren ervaring kijk ik nog steeds uit naar de nieuwe ontwikkelingen die gebeuren in deze taal.`
			},
			{
				title: "CSS",
				id: "css",
				icon: "logos/css.svg", 
				description: `Essentieel als webontwikkelaar is het kunnen gebruiken van CSS om in meerdere browsers een gelikte interface neer te zetten. Ook deze skill heb ik door de jaren heen verbeterd.`
			}/*,
			{
				title: "React",
				id: "react",
				icon: "logos/react.svg",
				description: `Met React ben ik vrij recent begonnen. Hoewel het een trend is in JavaScript om nieuwe frameworks te ontwikkelen, is React naar mijn mening fijn om mee te werken.`
			}*/
		]
	},
	{
		title: "Werkervaring",
		entryType: "spacestation",
		entries: [
			{
				company: "Quo Vide",
				logo: "quo-vide.svg",
				description: "Als stagair ben ik begonnen en uiteindelijk doorgegroeid naar een webdeveloper die zowel in teams als zelfstandig applicaties ontwikkelt, verbeterd en analyseert."
			},
			{
				company: "MobGen",
				logo: "mobgen.png",
				description: "Als afstudeerstage heb ik een platform ontwikkeld dat dient als een verzameling van algemene tools die gewenst waren. Op basis van meerdere testen met gebruikers is een systeem in elkaar gezet dat zowel qua interface, logica en techniek overeenkwam met de wensen en verwachtingen."
			},
			{
				company: "Albert Heijn",
				logo: "ah.svg",
				description: "Ik heb meerdere jaren gewerkt als vulploeg- en kassamedewerker bij een Albert Heijn vestiging. Hier heb ik de beginselen geleerd hoe om te gaan met klanten, stress en onvoorziene situaties."
			}
		]
	},
	{
		title: "Educatie",
		entryType: "asteroids",
		entries: [
			{
				institute: "Hogeschool van Amsterdam",
				logo: "hva.svg",
				description: "Bachelor Information and Technology · 2009 - 2013"
			},
			{
				institute: "Lyceum aan Zee",
				logo: "lyceum-aan-zee.png",
				description: "Havo · 2005 - 2009"
			}
		]
	},
	{
		title: "Contact",
		entryType: "contact"
	}
];


// WEBPACK FOOTER //
// ./src/CVEntries.js